import { render, staticRenderFns } from "./RecommendationsHeader.vue?vue&type=template&id=70392fe0"
import script from "./RecommendationsHeader.vue?vue&type=script&lang=js"
export * from "./RecommendationsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports